<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Regnskab/kontoplan</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="32" class="settings-list">
        <dt>Økonomisystem</dt>
        <dd>{{value.system}}</dd>

        @if (['uniconta', 'economic', 'multi_regnskab', 'opus'].includes(value.system)) {
          <dt>Eksporter posteringer</dt>
          <dd>{{value.export_postings ? 'Ja' : 'Nej'}}</dd>
        }

        @if (canExportAttachment.includes(value.system)) {
          <dt>Bilagsintegration</dt>
          <dd>{{value.export_posting_attachments ? 'Ja' : 'Nej'}}</dd>
        }

        @if (value.system === 'uniconta') {
          <dt>Klassekladde</dt>
          <dd>{{value.journal}}</dd>
          <dt>Kundenummer</dt>
          <dd>{{value.company_id}}</dd>
          <dt>Brugernavn</dt>
          <dd>{{value.username}}</dd>
          <dt>Adgangskode</dt>
          <dd>********</dd>
          @if (value.uniconta_fields?.length) {
            <dt>Uniconta Felter</dt>
            @for (field of value.uniconta_fields; track $index) {
              <dd>{{field.name}}: {{field.value}}</dd>
            }
          }
        }

        @if (value.system === 'opus') {
          <dt>Bogføringsdato som dags dato</dt>
          <dd>{{value.posting_date_as_current_date ? 'Ja' : 'Nej'}}</dd>
          <dt>Virksomhedskode (Comp Code)</dt>
          <dd>{{value.comp_code}}</dd>
          <dt>Kommunenummer</dt>
          <dd>{{value.municipality_no}}</dd>
          <dt>Produktionsmiljø</dt>
          <dd>{{value.prod_env}}</dd>
          <dt>System ID</dt>
          <dd>{{value.system_id}}</dd>
          <dt>Data Provider ID</dt>
          <dd>{{value.data_provider_id}}</dd>
        }

        @if (value.system === 'generic') {
          <dt>CSV Options</dt>
          <dd>{{value.csv_options | json}}</dd>
          <dt>Skip CSV Header</dt>
          <dd>{{value.csv_skip_header ? 'Ja' : 'Nej'}}</dd>
        }

        <dt>Krediteringskonto ved udbetaling</dt>
        <dd>{{value.payment_credit_account}}</dd>

        <dt>Krediteringskonto ved bevilling</dt>
        <dd>{{value.provision_account_no}}</dd>

        <dt>Debiteringskonto ved udbetaling</dt>
        <dd>{{value.payment_debit_account}}</dd>

        <dt>Debiteringskonto ved bevilling</dt>
        <dd>{{value.account_no}}</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="32" class="settings-list">
        <dt>Udbetaling / Modkonto kredit</dt>
        <dd>{{value.contra_credit_account_outgoing || '(ikke angivet)'}}</dd>

        <dt>Udbetaling / Modkonto debit</dt>
        <dd>{{value.contra_debit_account_outgoing || '(ikke angivet)'}}</dd>

        <dt>Vend kredit/debit</dt>
        <dd>{{value.flip_account_contra ? 'Ja' : 'Nej'}}</dd>

        <dt>Vend fortegn</dt>
        <dd>{{value.flip_sign ? 'Ja' : 'Nej'}}</dd>

        <dt>Indbetaling / Modkonto kredit</dt>
        <dd>{{value.contra_credit_account_incoming || '(ikke angivet)'}}</dd>

        <dt>Indbetaling / Modkonto debit</dt>
        <dd>{{value.contra_debit_account_incoming || '(ikke angivet)'}}</dd>

        <dt>Udlign kursdifferencer</dt>
        <dd>{{value.settle_exchange_rate_diff ? 'Ja' : 'Nej'}}</dd>

        @if (value.settle_exchange_rate_diff) {
          <dt>Valutadifference kredit</dt>
          <dd>{{value.exchange_rate_diff_credit_account}}</dd>

          <dt>Valutadifference debit</dt>
          <dd>{{value.exchange_rate_diff_debit_account}}</dd>
        }

      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="32" class="settings-list">
        <dt>Dimensioner</dt>
        <dd>Obligatorisk: {{value.dimension_mandatory ? 'Ja' : 'Nej'}}</dd>
        @if (!value.dimensions?.length) {
          <dd>Ingen dimensioner defineret.</dd>
        } @else {
          @for (dim of value.dimensions; track $index) {
            <dd>{{dim.name}} ({{dim.code}})</dd>
          }
        }
      </dl>
    </div>
  } @else {
    <form [formGroup]="form" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <div fxFlex="32">
        <div fxLayout="column" class="mb-3">
          <label id="accounting-system-label" for="accounting-system">Økonomisystem</label>
          <mat-form-field>
            <mat-select id="accounting-system" aria-labelledby="accounting-system-label"
              formControlName="system" (selectionChange)="handleSystemChange($event)">
              <mat-option value="generic">Generisk (GBusiness Solutions, Microsoft Dynamics (pull), ukendt)</mat-option>
              <mat-option value="uniconta">Uniconta</mat-option>
              <mat-option value="economic">e-conomic</mat-option>
              <mat-option value="multi_regnskab">MultiRegnskab</mat-option>
              <mat-option value="dynamic">Microsoft Dynamics (push)</mat-option>
              <mat-option value="opus">KMD Opus</mat-option>
            </mat-select>
            <mat-hint>Fondens økonomisystem, hvis vi overfører posteringer.</mat-hint>
            @if (form.controls['system'].hasError('required')) {
              <mat-error>Skal angives.</mat-error>
            }
          </mat-form-field>
        </div>

        @if (['uniconta', 'economic', 'multi_regnskab', 'opus'].includes(form.controls['system'].value)) {
          <div fxLayout="column" class="mb-3">
            <mat-checkbox formControlName="export_postings">Eksporter posteringer</mat-checkbox>
          </div>
          @if (form.controls['export_postings'].value) {
            @let sftpForm = form.get('sftp');
            <div fxLayout="column" class="mb-3" formGroupName="sftp">
              <label for="accounting-sftp-host">Serveradresse</label>
              <mat-form-field>
                <input id="accounting-sftp-host" class="new-form-control" type="text" matInput formControlName="host">
                @if (sftpForm.get('host').hasError('required')) {
                  <mat-error>Skal angives.</mat-error>
                }
              </mat-form-field>
              <label for="accounting-sftp-user">Brugernavn</label>
              <mat-form-field>
                <input id="accounting-sftp-user" class="new-form-control" type="text" matInput formControlName="user">
                @if (sftpForm.get('user').hasError('required')) {
                  <mat-error>Skal angives.</mat-error>
                }
              </mat-form-field>
              <mat-radio-group [formControl]="sftpSecretType" aria-label="Log ind på SFTP med nøgle eller kode">
                <mat-radio-button value="key">Nøgle</mat-radio-button>
                <mat-radio-button value="password_secret">Kode</mat-radio-button>
              </mat-radio-group>
              @if (sftpSecretType.value === 'key') {
                <label for="accounting-sftp-key">Nøgle</label>
                <mat-form-field>
                  <input id="accounting-sftp-key" class="new-form-control" type="password" placeholder="Indsæt nøgle"
                    matInput formControlName="key">
                </mat-form-field>
              } @else {
                <label for="accounting-sftp-password-secret">Kode</label>
                <mat-form-field>
                  @let passwordPlaceholder = passwordSecretPresent ? '••••••••' : 'Indsæt kode';
                  <input id="accounting-sftp-password-secret" class="new-form-control" type="password"
                    [placeholder]="passwordPlaceholder" matInput formControlName="password_secret">
                </mat-form-field>
              }
            </div>
          }
        }

        @if (form.controls['export_posting_attachments'].enabled) {
          <div fxLayout="column" class="mb-3">
            <mat-checkbox formControlName="export_posting_attachments">Bilagsintegration</mat-checkbox>
          </div>
        }
        @if (form.controls['system'].value === 'multi_regnskab') {
          <div formGroupName="multi_regnskab">
            <div fxLayout="column" class="mb-3">
              <label for="accounting-multi-regnskab-portfolio-customer-id">Kundenummer</label>
              <mat-form-field>
                <input id="accounting-multi-regnskab-portfolio-customer-id" class="new-form-control" type="text" matInput
                  formControlName="portfolio_customer_id">
                <mat-hint>MultiRegnskab kundenummer (PortfolioCustomerId)”</mat-hint>
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label for="accounting-multi-regnskab-authorization">Adgangskode</label>
              <mat-form-field>
                <input id="accounting-multi-regnskab-authorization" class="new-form-control" type="text" matInput
                  formControlName="authorization">
                <mat-hint>Adgangskode oplyses af MultiRegnskab.</mat-hint>
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label for="accounting-multi-regnskab-url">URL</label>
              <mat-form-field>
                <input id="accounting-multi-regnskab-url" class="new-form-control" type="text" matInput
                  formControlName="url">
                <mat-hint>URL til MultiRegnskab.</mat-hint>
              </mat-form-field>
            </div>
          </div>
        }

        @if (form.controls['system'].value === 'uniconta') {
          <div fxLayout="column" class="mb-3">
            <label for="accounting-company-id">Kundenummer</label>
            <mat-form-field>
              <input id="accounting-company-id" class="new-form-control" type="text" matInput formControlName="company_id">
              <mat-hint>Uniconta kundenummer</mat-hint>
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-username">Brugernavn</label>
            <mat-form-field>
              <input id="accounting-username" class="new-form-control" type="text" matInput formControlName="username">
              <mat-hint>Uniconta brugernavn</mat-hint>
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-password">Adgangskode</label>
            <mat-form-field>
              <input id="accounting-password" class="new-form-control" type="password" matInput formControlName="password">
              <mat-hint>Adgangskode</mat-hint>
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-journal">Klassekladde</label>
            <mat-form-field>
              <input id="accounting-journal" class="new-form-control" type="text" matInput formControlName="journal">
              <mat-hint>Navnet på den kassekladde, som GrantOne skal opretter posteringer på.</mat-hint>
            </mat-form-field>
          </div>

          <div fxLayout="column" class="mb-3" formArrayName="uniconta_fields">
            <label>Uniconta Felter</label>
            @for (field of uniconta_fields.value; let i = $index; track $index) {
              <div [formGroupName]="i" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em" class="mb-2">
                <mat-form-field fxFlex>
                  <input class="new-form-control" matInput formControlName="name" placeholder="Navn">
                </mat-form-field>
                <mat-form-field fxFlex>
                  <input class="new-form-control" matInput formControlName="value" placeholder="Værdi">
                </mat-form-field>
                <button mat-icon-button color="warn" (click)="doRemoveUnicontaField(i)" type="button"
                  matTooltip="Fjern Uniconta felt" aria-label="Fjern Uniconta felt">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
            <div>
              <button mat-stroked-button color="primary" (click)="doAddUnicontaField()" type="button">
                <mat-icon>add</mat-icon> Tilføj Uniconta felt
              </button>
            </div>
          </div>
        }

        @if (form.controls['system'].value === 'opus') {
          <div fxLayout="column" class="mb-3">
            <mat-checkbox formControlName="posting_date_as_current_date">Bogføringsdato som dags dato</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-comp-code">Virksomhedskode (Comp Code)</label>
            <mat-form-field>
              <input id="accounting-comp-code" class="new-form-control" type="text" matInput formControlName="comp_code">
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-municipality-no">Kommunenummer</label>
            <mat-form-field>
              <input id="accounting-municipality-no" class="new-form-control" type="text" matInput formControlName="municipality_no">
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-prod-env">Produktionsmiljø</label>
            <mat-form-field>
              <input id="accounting-prod-env" class="new-form-control" type="text" matInput formControlName="prod_env">
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-system-id">System ID</label>
            <mat-form-field>
              <input id="accounting-system-id" class="new-form-control" type="text" matInput formControlName="system_id">
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-data-provider-id">Data Provider ID</label>
            <mat-form-field>
              <input id="accounting-data-provider-id" class="new-form-control" type="text" matInput formControlName="data_provider_id">
            </mat-form-field>
          </div>
        }

        @if (form.controls['system'].value === 'generic') {
          <div fxLayout="column" class="mb-3">
            <mat-checkbox formControlName="csv_skip_header">Skip CSV Header</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-csv-options">CSV Options (JSON)</label>
            <mat-form-field>
              <textarea id="accounting-csv-options" matInput formControlName="csv_options"></textarea>
            </mat-form-field>
          </div>
        }
        <div fxLayout="column" class="mb-3">
          <label for="accounting-payment-credit-account">Krediteringskonto ved udbetaling</label>
          <mat-form-field>
            <input id="accounting-payment-credit-account" class="new-form-control" type="text" matInput
              formControlName="payment_credit_account">
            <mat-hint>Den konto, som skal krediteres ved en udbetaling</mat-hint>
            @if (form.controls['payment_credit_account'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['payment_credit_account'].hasError('pattern')) {
              <mat-error>Ugyldigt konto.</mat-error>
            }
            @if (form.controls['payment_credit_account'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['payment_credit_account'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <label for="accounting-provision-account-no">Krediteringskonto ved bevilling</label>
          <mat-form-field>
            <input id="accounting-provision-account-no" class="new-form-control" type="text" matInput
              formControlName="provision_account_no">
            <mat-hint>Den konto, som krediteres ved bevilling af en sag.</mat-hint>
            @if (form.controls['provision_account_no'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['provision_account_no'].hasError('pattern')) {
              <mat-error>Ugyldigt konto.</mat-error>
            }
            @if (form.controls['provision_account_no'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['provision_account_no'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <label for="accounting-payment-debit-account">Debiteringskonto ved udbetaling</label>
          <mat-form-field>
            <input id="accounting-payment-debit-account" class="new-form-control" type="text" matInput
              formControlName="payment_debit_account">
            <mat-hint>Debiteringskonto ved udbetaling. Angiv evt. kontotype og kontonummer adskilt af kolon, fx 'Finans:1234'</mat-hint>
            @if (form.controls['payment_debit_account'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['payment_debit_account'].hasError('pattern')) {
              <mat-error>Ugyldigt konto.</mat-error>
            }
            @if (form.controls['payment_debit_account'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['payment_debit_account'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <label for="accounting-account-no">Debiteringskonto ved bevilling</label>
          <mat-form-field>
            <input id="accounting-account-no" class="new-form-control" type="text" matInput formControlName="account_no">
            <mat-hint>Den konto, som debiteres ved bevilling af en sag.</mat-hint>
            @if (form.controls['account_no'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['account_no'].hasError('pattern')) {
              <mat-error>Ugyldigt konto.</mat-error>
            }
            @if (form.controls['account_no'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['account_no'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <mat-checkbox formControlName="flip_account_contra">Vend kredit-/debitkonto</mat-checkbox>
        </div>
        <div fxLayout="column" class="mb-3">
          <mat-checkbox formControlName="flip_sign">Vend fortegn</mat-checkbox>
        </div>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div fxFlex="32">
        <div fxLayout="column" class="mb-3">
          <label for="accounting-contra-credit-account-outgoing">Udbetaling / Modkonto kredit</label>
          <mat-form-field>
            <input id="accounting-contra-credit-account-outgoing" class="new-form-control" type="text" matInput
              formControlName="contra_credit_account_outgoing">
            <mat-hint>Hvis fonden benytter modkonto ved udbetaling angives kredit og debit.</mat-hint>
            @if (form.controls['contra_credit_account_outgoing'].hasError('pattern')) {
              <mat-error>Ugyldigt konto.</mat-error>
            }
            @if (form.controls['contra_credit_account_outgoing'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['contra_credit_account_outgoing'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <label for="accounting-contra-debit-account-outgoing">Udbetaling / Modkonto debit</label>
          <mat-form-field>
            <input id="accounting-contra-debit-account-outgoing" class="new-form-control" type="text" matInput
              formControlName="contra_debit_account_outgoing">
            <mat-hint>Hvis fonden benytter modkonto ved indbetaling angives kredit og debit.</mat-hint>
            @if (form.controls['contra_debit_account_outgoing'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['contra_debit_account_outgoing'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <label for="accounting-contra-credit-account-incoming">Indbetaling / Modkonto kredit</label>
          <mat-form-field>
            <input id="accounting-contra-credit-account-incoming" class="new-form-control" type="text" matInput
              formControlName="contra_credit_account_incoming">
            <mat-hint>Hvis fonden benytter modkonto ved indbetaling angives kredit og debit.</mat-hint>
            @if (form.controls['contra_credit_account_incoming'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['contra_credit_account_incoming'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <label for="accounting-contra-debit-account-incoming">Indbetaling / Modkonto debet</label>
          <mat-form-field>
            <input id="accounting-contra-debit-account-incoming" class="new-form-control" type="text" matInput
              formControlName="contra_debit_account_incoming">
            <mat-hint>Hvis fonden benytter modkonto ved udbetaling angives kredit og debet.</mat-hint>
            @if (form.controls['contra_debit_account_incoming'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['contra_debit_account_incoming'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <mat-checkbox formControlName="settle_exchange_rate_diff">Udlign kursdifference</mat-checkbox>
        </div>
        @if (form.controls['settle_exchange_rate_diff'].value) {
          <div fxLayout="column" class="mb-3">
            <label for="accounting-exchange-rate-diff-credit-account">Kursdifference kredit</label>
            <mat-form-field>
              <input id="accounting-exchange-rate-diff-credit-account" class="new-form-control" type="text" matInput
                formControlName="exchange_rate_diff_credit_account">
              <mat-hint>Kreditkonto for kursdifference, hvis automatisk udligning er aktiveret.</mat-hint>
              @if (form.controls['exchange_rate_diff_credit_account'].hasError('minlength')) {
                <mat-error>Mindst 3 tegn.</mat-error>
              }
              @if (form.controls['exchange_rate_diff_credit_account'].hasError('maxlength')) {
                <mat-error>Højst 20 tegn.</mat-error>
              }
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label for="accounting-exchange-rate-diff-debit-account">Kursdifference debit</label>
            <mat-form-field>
              <input id="accounting-exchange-rate-diff-debit-account" class="new-form-control" type="text" matInput
                formControlName="exchange_rate_diff_debit_account">
              <mat-hint>Debitkonto for kursdifference, hvis automatisk udligning er aktiveret.</mat-hint>
              @if (form.controls['exchange_rate_diff_debit_account'].hasError('minlength')) {
                <mat-error>Mindst 3 tegn.</mat-error>
              }
              @if (form.controls['exchange_rate_diff_debit_account'].hasError('maxlength')) {
                <mat-error>Højst 20 tegn.</mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div fxFlex="32">
        <div fxLayout="column" class="mb-3">
          <label for="accounting-intermediate-account">Mellemregningskonto ved betaling</label>
          <mat-form-field>
            <input id="accounting-intermediate-account" class="new-form-control" type="text" matInput
              formControlName="intermediate_account">
            <mat-hint>Den konto, som posteres hvis betalingerne ikke skal posteres til banken.</mat-hint>
            @if (form.controls['intermediate_account'].hasError('minlength')) {
              <mat-error>Mindst 3 tegn.</mat-error>
            }
            @if (form.controls['intermediate_account'].hasError('maxlength')) {
              <mat-error>Højst 20 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <label for="accounting-economic-posting-text">Posteringstekst (e-conomic)*</label>
          <mat-form-field>
            <input id="accounting-economic-posting-text" class="new-form-control" type="text" matInput
              [formControl]="economic_posting_text">
            <mat-hint>Skabelon for posteringstekst. Flettefelter journal_no, title, name, entity_id og note.</mat-hint>
            @if (economic_posting_text.hasError('required')) {
              <mat-error>Skal angives.</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column" class="mb-3">
          <mat-checkbox formControlName="dimension_mandatory" class="mb-2">Dimensioner obligatoriske</mat-checkbox>
        </div>
        <div fxLayout="column" class="mb-3" formArrayName="dimensions">
          <label>Dimensioner</label>
          @for (dim of dimensions.value; let i = $index; track $index) {
            <div [formGroupName]="i" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em" class="mb-2">
              <mat-form-field fxFlex>
                <input class="new-form-control" matInput formControlName="name" placeholder="Navn">
              </mat-form-field>
              <mat-form-field fxFlex>
                <input class="new-form-control" matInput formControlName="code" placeholder="Kode">
              </mat-form-field>
              <button mat-icon-button color="warn" (click)="doRemoveDimension(i)" type="button"
                matTooltip="Fjern dimension" aria-label="Fjern dimension">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
          <div>
            <button mat-stroked-button color="primary" (click)="doAddDimension()" type="button">
              <mat-icon>add</mat-icon> Tilføj dimension
            </button>
          </div>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-raised-button color="primary" (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-raised-button color="accent" (click)="doCancel()">Fortryd</button>
        <button mat-raised-button color="primary" (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
